<div class="endorsement-pdf-page app-aul-104-24">
  <!-- <app-policy-header></app-policy-header> -->
  @if (isNewJerseyEndorsement() && getNJTN()) {
    <div style="font-size:22px; margin-bottom: 10px; text-align: right;">
      <b>New Jersey Transaction Number {{ getNJTN() }}</b>
    </div>
  }
  <p style="font-size:22px; text-align:center;">
    <b>COMMERCIAL PROPERTY ENDORSEMENT</b>
  </p>
  <p style="font-size:22px; text-align:center;">
    <b>THIS ENDORSEMENT CHANGES THE POLICY. PLEASE READ CAREFULLY.</b>
  </p>
  <p style="font-size:19px;">
    <b>
      This endorsement and the attached Supplemental Declarations Page and
      Schedule of Forms (If applicable) attach to and form part of the Policy
      numbered: {{ endorsementDetails?.policyId }}
    </b>
  </p>
  <table style="width:100%;font-size:19px;">
    <tbody>
      <tr>
        <td style="width:50%;">
          <b
            >Endorsement Number:
            <span>{{ endorsementDetails?.endorsementNumber }}</span></b
          >
        </td>
        <td style="width:50%;">
          <b
            >Endorsement Inception Date:<span>{{
              endorsementDetails?.endorsementInceptionDate | date : "MM/dd/yyyy"
            }}</span></b
          >
        </td>
      </tr>
    </tbody>
  </table>
  <p style="font-size:19px;">
    Based on the information provided by you and in consideration of the Total
    Endorsement Premium, the policy has been changed with effect from the
    Endorsement Inception Date.
  </p>
  <p style="font-size:19px;">
    The attached Supplemental Declarations Page and Schedule of Forms (If
    applicable) replace any previously issued.
  </p>
  <br />
  <p style="font-size:19px;">
    <b>Endorsement type: {{ endorsementDetails?.endorsementType }}</b>
  </p>
  <br />
  <p style="font-size:19px;">
    <b>Endorsement Summary Description:</b>
  </p>
  <p style="font-size:19px;">
    <b>{{ endorsementDetails?.endorsementDescription }}</b>
  </p>
  <br />
  <table style="width:100%;font-size:19px;">
    <tbody>
      <tr>
        <td style="width:50%;"><b>Coverage Part</b></td>
        <td style="width:50%;"><b>Premium</b></td>
      </tr>
      <tr>
        <td style="width:50%;">Commercial Property Coverage Part</td>
        <td style="width:50%;">$ {{ endorsementDetails?.commericalPropCovPart }}</td>
      </tr>
      <tr>
        <td style="width:50%;"><b>Total Endorsement Premium</b></td>
        <td style="width:50%;">
          <b>$ {{ endorsementDetails?.totalPolicyPremium }}</b>
        </td>
      </tr>
    </tbody>
  </table>
  <br />
  <p style="font-size:14px; margin-bottom:0px;">
    All Policy, Administration and/or Inspection Fees charged under this
    Endorsement and/or identified on the Commercial Property Insurance Policy
    Jacket or in the Declarations Page are fully earned as of the Endorsement
    inception date and are not refundable.
  </p>
  <br />
  <p style="font-size:14px;">
    <b>
      SURPLUS LINES INSURERS’ POLICY RATES AND FORMS ARE NOT APPROVED BY ANY
      STATE REGULATORY AGENCY. PERSONS INSURED BY SURPLUS LINES INSURERS DO NOT
      HAVE THE PROTECTION OF ANY STATE GUARANTY ACT TO THE EXTENT OF ANY RIGHT
      OF RECOVERY FOR THE OBLIGATION OF AN INSOLVENT UNLICENSED INSURER. SEE
      POLICY FOR SURPLUS LINES NOTICE.
    </b>
  </p>
  <br />
  <p style="font-size:14px; margin-bottom:0px;">
    The Agent named in this policy is responsible for calculating and remitting
    any and all surplus lines taxes and fees that may apply to this Policy.
  </p>
  <br />
  <p style="font-size:14px; margin-bottom:0px;">
    The issuance of this insurance is facilitated by Alchemy Underwriting
    Limited (AUL) on behalf of Insurers identified within the policy and in
    accordance with the authorization granted to AUL and its affiliates. AUL is
    not an insurer under this policy and is not liable to indemnify the insured
    under the terms of this policy.
  </p>
</div>
